import {h} from 'preact'
import {Route, RouteComponentProps} from 'wouter'
import codeSplit from 'code-split.macro'
import asyncComponent from 'create-async-component'

export const pages: JSX.Element[] = [
  createRoute('styles'),
  createRoute('react-layout'),
  createRoute('react'),
  createRoute('spacing'),
  createRoute('grid'),
  createRoute('mq'),
  createRoute('transition'),
  createRoute('jest'),
  <Route
    key='home'
    path='/'
    component={asyncComponent(codeSplit('./Home', __SERVER__), {
      property: 'Home',
    })}
  />,
]

export const sections = {
  styles: {
    'getting-started': asyncComponent(
      codeSplit('./styles/0-getting-started.mdx', __SERVER__)
    ),
    api: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
    patterns: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
    typescript: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
  },
  react: {
    'getting-started': asyncComponent(
      codeSplit('./styles/0-getting-started.mdx', __SERVER__)
    ),
    api: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
    typescript: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
  },
  'react-layout': {
    'getting-started': asyncComponent(
      codeSplit('./styles/0-getting-started.mdx', __SERVER__)
    ),
    api: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
    typescript: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
  },
  spacing: {
    'getting-started': asyncComponent(
      codeSplit('./styles/0-getting-started.mdx', __SERVER__)
    ),
    api: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
    typescript: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
  },
  grid: {
    'getting-started': asyncComponent(
      codeSplit('./styles/0-getting-started.mdx', __SERVER__)
    ),
    api: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
    typescript: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
  },
  mq: {
    'getting-started': asyncComponent(
      codeSplit('./styles/0-getting-started.mdx', __SERVER__)
    ),
    api: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
    typescript: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
  },
  transition: {
    'getting-started': asyncComponent(
      codeSplit('./styles/0-getting-started.mdx', __SERVER__)
    ),
    api: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
    typescript: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
  },
  jest: {
    'getting-started': asyncComponent(
      codeSplit('./styles/0-getting-started.mdx', __SERVER__)
    ),
    api: asyncComponent(codeSplit('./styles/1-api.mdx', __SERVER__)),
  },
}

function createRoute(section: keyof typeof sections): JSX.Element {
  const children: React.FC<RouteComponentProps<{page?: string}>> = (props) =>
    h(sections[section][props.params.page || 'getting-started'], props)

  return (
    <Route key={section} path={`/${section}/:page?`} component={children} />
  )
}
